import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as CheckboxChecked } from '../../assets/images/checkbox_checked.svg';
import { ReactComponent as CheckboxUnchecked } from '../../assets/images/checkbox_unchecked.svg';
import './CustomCheckbox.scss';

const CustomCheckbox = ({
  checked,
  checkedColor = 'var(--dark_orange)',
  uncheckedColor = 'var(--greyscale_48)',
  uncheckedFill = 'var(--greyscale_08)',
  onChange,
  value,
  customClassName,
}) => {
  return (
    <div
      className={`custom-checkbox ${customClassName || ''}`}
      onClick={(e) => {
        e.stopPropagation();
        onChange?.(e);
      }}
    >
      {checked ? (
        <CheckboxChecked color={checkedColor} />
      ) : (
        <CheckboxUnchecked fill={uncheckedFill} color={uncheckedColor} />
      )}
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        value={value}
        style={{ display: 'none' }}
      />
    </div>
  );
};

CustomCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  checkedColor: PropTypes.string,
  uncheckedColor: PropTypes.string,
  uncheckedFill: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
  className: PropTypes.string,
};

export default CustomCheckbox;
